import { ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { generatePath } from 'react-router-dom';

export enum MANAGE_DOCUMENT_TEMPLATES_ROUTES {
	CREATE = 'create',
	EDIT = 'edit/:templateId',
}

export const documentTemplateEditPath = (templateId: string): string =>
	generatePath(`${ROUTES.TEMPLATES}/${MANAGE_DOCUMENT_TEMPLATES_ROUTES.EDIT}`, { templateId });
